import { render, staticRenderFns } from "./PublisherSelector.vue?vue&type=template&id=6708acf9&scoped=true"
import script from "./PublisherSelector.vue?vue&type=script&lang=js"
export * from "./PublisherSelector.vue?vue&type=script&lang=js"
import style0 from "./PublisherSelector.vue?vue&type=style&index=0&id=6708acf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6708acf9",
  null
  
)

export default component.exports